import {} from './mutation-types.js';
import { asyncRouterMap } from '@/router/router';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr';

function hasPermission(right, route) {
  if (route.meta && route.meta.right.length > 0) {
    if (process.env.NODE_ENV === 'development') {
      return true;
    } else if (process.env.NODE_ENV === 'production') {
      return true;
      // return route.meta.right.some(childright => {
      //   return right.indexOf(childright) >= 0;
      // });
    }
  } else {
    return true;
  }
}
// 递归遍历将字符串的component转为对象
// function tranComponent(router) {
//   router.forEach((item, index) => {
//     router[index].component = eval(item.component);
//     if (item.children && item.children.length > 0) {
//       tranComponent(item.children)
//     }
//   })
//   return router;
// }
function recRouter(right, Router) {
  return Router.filter((item) => {
    if (hasPermission(right, item)) {
      if (item.children && item.children.length > 0) {
        item.children = recRouter(right, item.children);
        return item;
      } else {
        return item;
      }
    } else {
      return false;
    }
  });
}
let getnewRouter = [
  {
    path: '/index',
    name: '首页',
  },
];

export default {
  async GenerateRoutes({ commit }, data) {
    return new Promise((resolve, reject) => {
      const right = data.right;
      // new routerSvr().GetMenus(state.token).then(res => {
      //   asyncRouterMap[0].children = asyncRouterMap[0].children.concat(tranComponent(res))
      //   const accessedRouters = recRouter(right, asyncRouterMap)
      //   commit('SET_ROUTERS', accessedRouters);
      //   resolve();
      // }).catch(err => {
      //   reject(err)
      // })
      try {
        const accessedRouters = recRouter(right, asyncRouterMap);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      } catch (err) {
        reject(err);
      }
      // asyncRouterMap.filter(v => {
      //   if (hasPermission(right, v)) {
      //     if (v.children && v.children.length > 0) {
      //       v.children = v.children.filter(child => {
      //         if (hasPermission(right, child)) {
      //           if(child.children&&child.children.length>0){
      //             child.children=child.children.filter(son=>{
      //               if(hasPermission(right, son)){
      //                 return son;
      //               }else{
      //                 return false
      //               }
      //             })
      //           }else{
      //             return child;
      //           }
      //           return child
      //         }
      //         return false;
      //       });
      //       return v
      //     } else {
      //       return v
      //     }
      //   }
      //   return false;
      // });
    });
  },
  GetUserInfo({ state, commit }) {
    return new Promise((resolve, reject) => {
      try {
        new AuthenticationControllerSvr()
          .getUserDetail(state.token, 1)
          .then((res) => {
            if (res.error_respone) {
              reject(res.error_respone);
            } else {
              commit('SET_USERINFO', res);
              resolve(res);
            }
          })
          .catch((err) => {
            err;
            reject(err);
          });
        // commit('SET_USERINFO', JSON.parse(getUser()));
        // commit('SET_TOKEN', JSON.parse(getUser()).Token);
      } catch (err) {
        reject(err);
      }
      // new AuthenticationControllerSvr()
      //   .GetUserDetail(state.token)
      //   .then(response => {
      //     const data = response;
      //     if (data.UserParam && data.UserParam.UserType) {
      //       // 验证返回的roles是否是一个非空数组
      //       commit('SET_USERINFO', data);
      //     } else {
      //       reject('getInfo: right must be a non-null array !');
      //     }
      //     resolve(response);
      //   })
      //   .catch(error => {
      //     reject(error);
      //   });
    });
  },
  GetUserRoleInfo({ state, commit }) {
    return new Promise((resolve, reject) => {
      try {
        resolve();
        new AuthenticationControllerSvr()
          .getUserRole(state.token)
          .then((res) => {
            if (res.UNIQID) sessionStorage.setItem('UNIQID', res.UNIQID);
            if (res && res.RoleList && res.RoleList.length > 0) {
              sessionStorage.setItem(
                'roleInfo',
                JSON.stringify(res.RoleList[0])
              );
            }
            if (res.error_respone) {
              reject(res.error_respone);
            } else {
              let roleObj = res;
              if (res && res.RoleList) {
                res.RoleList.forEach((item) => {
                  if (item.Loginflag == 1) {
                    roleObj.ROLE = item.Remark;
                    roleObj.ID = item.Id;
                  }
                });
              }
              if (
                !roleObj.ID ||
                (!roleObj.ROLE &&
                  res &&
                  res.RoleList &&
                  res.RoleList.length > 0)
              ) {
                roleObj.ROLE = res.RoleList[0].Remark;
                roleObj.ID = res.RoleList[0].Id;
              }
              commit('SET_USERROLEINFO', roleObj);
              resolve(roleObj);
            }
          })
          .catch((err) => {
            err;
            reject(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  },
  GetTabsRouter({ commit }, router) {
    return new Promise((resolve, reject) => {
      try {
        let rout = {
          path: router.path,
          hash: router.hash,
          name: router.name,
          meta: router.meta,
          params: router.params,
          query: router.query
        };
        commit('SET_TABS', rout);
        resolve(rout);
      } catch (err) {
        reject(err);
      }
    });
  },
  updateTabsRouter({ commit }, newTabsRouter) {
    return new Promise((resolve, reject) => {
      try {
        commit('SET_TABS_ROUTER', newTabsRouter);
        resolve(newTabsRouter);
      } catch (err) {
        reject(err);
      }
    });
  },
  DeleTabsRouter({ commit, state }, idx) {
    return new Promise((resolve, reject) => {
      try {
        commit('DEL_TABS', idx); // 这将调用 mutation 来修改 state.tabsRouter

        // let rout = state.tabsRouter.map(route => ({
        //   path: route.path,
        //   hash: route.hash,
        //   name: route.name,
        //   meta: route.meta,
        //   params:route.params,
        //   query:route.query
        // }));
        // getnewRouter = JSON.stringify(rout)
        // console.warn(getnewRouter,'rout');
        // sessionStorage.setItem('listRouter', getnewRouter);
        resolve(); // 解析 Promise 并返回更新后的 tabsRouter 数组
      } catch (err) {
        reject(err); // 如果有错误发生，在这里拒绝 Promise
      }
    });
  },
  DelTabsArr({ commit }, obj) {
    return new Promise((resolve, reject) => {
      try {
        commit('DEL_TABSARR', obj);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  },
  DelTabsOther({ commit }, idx) {
    return new Promise((resolve, reject) => {
      try {
        commit('DEL_TABSOTHER', idx);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  },
  SetCurrentPage({ commit }, val) {
    commit('SET_CURENTPAGE', val);
  },
  SetPageCount({ commit }, val) {
    commit('SET_PAGECOUNT', val);
  },
  SetCode({ commit }, val) {
    commit('SET_CODE', val);
  },
};
